// User-facing date formatting. Dates show as dd/mm/yyyy (en-GB), optionally with
// time. Centralised so every user surface formats dates the same way.

const DATE_OPTS = { day: '2-digit', month: '2-digit', year: 'numeric' };
const DATETIME_OPTS = { ...DATE_OPTS, hour: '2-digit', minute: '2-digit' };

function toDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

// dd/mm/yyyy
export function formatDate(value) {
  const d = toDate(value);
  return d ? d.toLocaleDateString('en-GB', DATE_OPTS) : '';
}

// dd/mm/yyyy, hh:mm
export function formatDateTime(value) {
  const d = toDate(value);
  return d ? d.toLocaleString('en-GB', DATETIME_OPTS) : '';
}

// hh:mm, for a column that already shows the date.
export function formatTime(value) {
  const d = toDate(value);
  return d ? d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '';
}

// "14 October 2026": the topbar's date line. Long form on purpose -- it sits
// beside the greeting as prose, not in a data column -- but still unambiguous
// (day first, month spelled out) and still from this one module.
export function formatLongDate(value) {
  const d = toDate(value);
  return d ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
}
